import { useRef } from "react";
const useDoubleRef = (value) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
export {
  useDoubleRef
};
//# sourceMappingURL=index223.js.map
